export type WorkerTier = 'gold' | 'silver' | 'bronze' | 'probationary'

export const TIER_LABELS: Record<WorkerTier, string> = {
  gold: 'Gold',
  silver: 'Silver',
  bronze: 'Bronze',
  probationary: 'Probationary',
}

export const TIER_HEX: Record<WorkerTier, string> = {
  gold: '#C8A84B',
  silver: '#7A94A0',
  bronze: '#B87040',
  probationary: '#8099A8',
}

/** Tailwind background for a tier's swatch - the class-name twin of TIER_HEX, for markup that isn't an inline style. */
export const TIER_BG_CLASS: Record<WorkerTier, string> = {
  gold: 'bg-gold',
  silver: 'bg-silver',
  bronze: 'bg-bronze',
  probationary: 'bg-prob',
}
